var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.984 6.422L13.406 12l5.578 5.578-1.406 1.406L12 13.406l-5.578 5.578-1.406-1.406L10.594 12 5.016 6.422l1.406-1.406L12 10.594l5.578-5.578z"
  })));
};
export default SvgClose;